module.exports = __webpack_public_path__ + "img/5.dbce4f0d.png";